// extracted by css-extract-rspack-plugin
export default {"fullWidth":"YvSXbmRPUhXT5U_4"};